import { render, staticRenderFns } from "./CreateRoleModal.vue?vue&type=template&id=5c5a4662&scoped=true&"
import script from "./CreateRoleModal.vue?vue&type=script&lang=js&"
export * from "./CreateRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleModal.vue?vue&type=style&index=0&id=5c5a4662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a4662",
  null
  
)

export default component.exports